<template>
  <div class="mb-4">
    <b-jumbotron class="title_page">
      <h1 class="text-center font-weight-bold">TERMO DE USO</h1>
    </b-jumbotron>
    <bread-cpv class="adjustment-breadcrumb"></bread-cpv>

    <b-container fluid="xl">
      <div class="termos-de-uso">
        <h1>Termos de Uso - CPV Educacional</h1>

        <h2>Introdução</h2>
        <p>
          Prezado Usuário(a), seja bem-vindo à Plataforma do CPV Educacional. Este documento ("Termos de Uso") rege sua
          utilização dos serviços disponibilizados pel0 CPV Educacional.
        </p>
        <p>
          Antes de utilizar a Plataforma do CPV Educacional, certifique-se de ler atentamente estes Termos de Uso e a
          nossa Política de Privacidade e Uso de Dados, parte integrante deste documento, disponível em [link]. Ao criar
          uma conta ou utilizar os serviços disponibilizados pelo CPV Educacional, você confirma que compreendeu e
          concorda integralmente com os termos aqui estabelecidos.
        </p>

        <h2>1. Objeto</h2>
        <p>
          Estes Termos regulam o acesso e uso da Plataforma do CPV Educacional, uma ferramenta que conta com
          funcionalidades para realização de matrícula online e gestão de informações do aluno.
        </p>

        <h2>2. Cadastro e Acesso</h2>
        <p>
          O usuário cadastrado receberá um login e senha para acesso exclusivo e pessoal à Plataforma, obrigando-se a
          mantê-los sob sigilo e segurança, comunicando imediatamente ao CPV Educacional quaisquer suspeitas de uso
          indevido.
        </p>
        <p>
          O usuário compromete-se a fornecer e manter sempre atualizadas informações cadastrais completas e verdadeiras.
        </p>

        <h2>3. Responsabilidades do Usuário</h2>
        <p>O Usuário declara expressamente:</p>
        <ul>
          <li>possuir capacidade legal;</li>
          <li>não criar múltiplas contas ou utilizar identidades falsas;</li>
          <li>não realizar atividades ilícitas ou fraudulentas na Plataforma;</li>
          <li>zelar pela segurança dos dados pessoais e de acesso fornecidos;</li>
          <li>comunicar imediatamente qualquer suspeita de atividade inadequada ou violação de segurança;</li>
          <li>respeitar todos os direitos de propriedade intelectual da CPV Educacional.</li>
        </ul>

        <h2>4. Condutas Proibidas</h2>
        <p>É expressamente vedado ao usuário:</p>
        <ul>
          <li>
            copiar, reproduzir, distribuir ou comercializar os conteúdos e tecnologias do CPV Educacional sem
            autorização prévia;
          </li>
          <li>utilizar a Plataforma para inserir conteúdos ofensivos, ilegais ou discriminatórios;</li>
          <li>
            tentar realizar engenharia reversa, decodificação ou qualquer atividade que viole a segurança da Plataforma;
          </li>
          <li>usar técnicas automatizadas para coleta ou extração de dados da Plataforma (web scraping);</li>
          <li>prejudicar o funcionamento regular ou interferir na segurança da Plataforma ou de seus usuários;</li>
          <li>compartilhar acesso ou informações confidenciais obtidas na Plataforma sem autorização expressa;</li>
          <li>violar quaisquer direitos de propriedade intelectual ou industrial.</li>
        </ul>

        <h2>5. Bloqueio, Suspensão e Cancelamento de Cadastro</h2>
        <p>
          O CPV Educacional poderá bloquear, suspender ou cancelar o cadastro de usuários, sem aviso prévio, caso seja
          identificada:
        </p>
        <ul>
          <li>violação dos presentes Termos ou da legislação vigente;</li>
          <li>fornecimento de informações falsas ou imprecisas;</li>
          <li>uso inadequado ou suspeita de fraude ou atividade ilícita.</li>
        </ul>

        <h2>6. Propriedade Intelectual</h2>
        <p>
          Todos os direitos relacionados à Plataforma, incluindo código-fonte, marcas, logotipos, tecnologias e
          conteúdos são de exclusiva propriedade do CPV Educacional ou licenciados a ele. Nenhum direito ou licença é
          concedido ao usuário além do uso estritamente necessário para acessar e usufruir dos serviços da Plataforma.
        </p>

        <h2>7. Licenciamento de Conteúdo</h2>
        <p>
          O usuário, ao inserir conteúdos na Plataforma, concede ao CPV Educacional uma licença gratuita, não exclusiva
          e global para utilizar tais conteúdos exclusivamente para fins internos, de aprimoramento, análise e para a
          prestação dos serviços contratados.
        </p>

        <h2>8. Confidencialidade e Proteção de Dados</h2>
        <p>
          O CPV Educacional compromete-se a adotar medidas adequadas para garantir a confidencialidade e segurança dos
          dados inseridos na Plataforma, conforme estabelecido em sua Política de Privacidade.
        </p>
        <p>
          O usuário compromete-se igualmente a não divulgar informações sensíveis ou dados pessoais obtidos na
          Plataforma para fins não autorizados.
        </p>

        <h2>9. Limitação de Responsabilidade</h2>
        <p>O CPV Educacional não será responsável por:</p>
        <ul>
          <li>danos indiretos, incidentais ou consequentes decorrentes do uso da Plataforma;</li>
          <li>
            indisponibilidade temporária ou interrupções do serviço causadas por falhas técnicas, manutenção, ataques
            cibernéticos ou eventos fora do controle razoável do CPV Educacional;
          </li>
          <li>conteúdos inseridos pelos usuários que violem direitos de terceiros ou a legislação vigente.</li>
        </ul>

        <h2>10. Indenização</h2>
        <p>
          O usuário compromete-se a indenizar o CPV Educacional em caso de prejuízos decorrentes de violações destes
          Termos de Uso ou de legislação aplicável, mediante comprovação dos danos sofridos.
        </p>

        <h2>11. Alterações dos Termos</h2>
        <p>
          O CPV Educacional reserva-se o direito de alterar estes Termos a qualquer momento, mediante aviso prévio de no
          mínimo 15 dias úteis por meio da Plataforma ou comunicação direta aos usuários.
        </p>

        <h2>12. Disposições Gerais</h2>
        <p>
          Estes Termos constituem acordo integral entre as partes, substituindo quaisquer entendimentos anteriores
          relacionados ao uso da Plataforma.
        </p>
        <p>A invalidade parcial destes Termos não compromete a validade das demais cláusulas.</p>
        <p>
          As comunicações referentes a estes Termos devem ser realizadas via e-mail cadastrado pelo usuário ou pelo
          canal de atendimento: <a href="mailto:contato@cpv.com.br">contato@cpv.com.br</a>.
        </p>

        <h2>13. Legislação Aplicável e Foro</h2>
        <p>
          Este documento é regido pelas leis da República Federativa do Brasil. As partes elegem o foro da Comarca de
          São Paulo/SP para resolver quaisquer controvérsias decorrentes destes Termos.
        </p>

        <p><em>Última atualização: 22 de maio de 2025.</em></p>
      </div>
    </b-container>
  </div>
</template>

<script>
import BreadCpv from "@/components/global/bread-cpv.vue";
export default {
  name: "TermsOfUse",
  components: { BreadCpv },
  data() {
    return {
      //
    };
  },
  created: function () {
    //
  },
  beforeDestroy: function () {
    //
  },
  methods: {
    //
  },
};
</script>

<style lang="scss" scoped>
.termos-de-uso {
  max-width: 800px;
  margin: auto;
  padding: 20px;
  font-family: "Arial", sans-serif;
  line-height: 1.6;
}

.termos-de-uso h1,
.termos-de-uso h2 {
  color: #333;
  margin-top: 20px;
}

.termos-de-uso ul {
  margin-left: 20px;
  list-style-type: disc;
}

@media (min-width: 1200px) {
  .main-bolsa {
    width: 100%;
    height: auto;
  }

  .title_page {
    margin: -8px 0px 0px !important;
    padding: 55px 0px 50px;
    background-repeat: repeat;
    background-position: center;
    background-color: rgb(239, 72, 87);
    background-image: url("https://d1jehvsxq7tgfk.cloudfront.net/sitecpv/images/cpv-fundo-4.png");
    background-size: 30%;
    // background-attachment: fixed;
    object-fit: cover;
    border-radius: 0;

    h1 {
      font-size: 51px;
      font-weight: 700;
      color: #ffffff;
      text-transform: uppercase;
      font-family: "FF Clan Pro", sans-serif;
    }
  }

  .header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgb(58, 28, 83);
  }

  .header h4 {
    font-size: 26px;
    font-weight: bold;
    line-height: 1.385;
    letter-spacing: 0.81px;
    text-transform: uppercase;
    text-align: center;
  }

  .header h4 .emphasis {
    color: rgb(239, 72, 87);
  }

  .content-bolsa {
    width: 100%;
    display: flex;
    align-items: left;
    justify-content: left;
    flex-direction: column;
    color: #333333;
  }

  .content-bolsa h6,
  h5 {
    font-size: 20px;
    color: rgb(58, 28, 83);
  }

  .content-bolsa h6 .emphasis,
  .content-bolsa h5 .emphasis {
    color: rgb(239, 72, 87);
  }

  .content-bolsa span {
    font-weight: bold;
  }

  .content-bolsa .info-prova {
    width: 100%;
    height: auto;
    display: flex;
    align-items: left;
    justify-content: left;
    flex-direction: column;
  }

  .content-bolsa .info-prova h4 {
    font-size: 22px;
    font-weight: bold;
  }

  .content-bolsa .info-prova ul {
    margin-left: 2%;
  }
  .content-bolsa .info-prova ul li span {
    font-weight: bold;
  }
  .content-bolsa .info-prova ul li {
    padding: 5px 0px;
  }
  .content-bolsa .info-prova ul li a {
    font-weight: bold;
    color: #333333;
    text-decoration: none;
  }
  .content-bolsa .info-prova ul li a:hover {
    font-weight: bold;
    color: rgb(239, 72, 87);
    text-decoration: none;
    transition: all 0.3s ease;
  }

  .button-inscricao .btn_insc {
    height: 56px;
    width: 35% !important;
  }

  .button-inscricao .btn_inscricao {
    border: 2px solid rgb(239, 72, 87);
    border-radius: 5px;
    background-color: rgb(239, 72, 87);
    // box-shadow: 0px 0px 30px rgba(1, 41, 141, 0.25);
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
  }

  .button-inscricao .btn_inscricao span {
    color: #ffffff;
    text-transform: uppercase;
  }

  .content-bolsa-font {
    font-family: "Clan-Book Book", sans-serif;
    font-size: 16px;
  }
}

@media only screen and (min-width: 768px) and (max-width: 1200px) {
  .main-bolsa {
    width: 100%;
    height: auto;
    font-size: 16px;
    margin: 80px 0;
  }

  .title_page {
    margin: -20px 0px -10px;
    padding: 55px 0px 50px;
    background-repeat: repeat;
    background-position: center;
    background-color: rgb(259, 72, 87);
    background-image: url("https://d1jehvsxq7tgfk.cloudfront.net/sitecpv/images/cpv-fundo-4.png");
    border-radius: 0;
  }

  .title_page h1 {
    font-size: 41px;
    font-weight: 700;
    color: #ffffff;
    text-transform: uppercase;
    font-family: "FF Clan Pro", sans-serif;
  }

  .adjustment-breadcrumb {
    margin: 10px 0 50px !important;
  }

  .header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .header h4 {
    font-size: 26px;
    font-weight: bold;
    line-height: 1.385;
    letter-spacing: 0.81px;
    text-transform: uppercase;
    text-align: center;
    color: rgb(58, 28, 83);
  }

  .header h4 .emphasis {
    color: rgb(239, 72, 87);
  }

  .content-bolsa {
    width: 100%;
    display: flex;
    align-items: left;
    justify-content: left;
    flex-direction: column;
    color: #333333;
  }

  .content-bolsa h6,
  h5 {
    font-size: 20px;
    color: rgb(58, 28, 83);
  }

  .content-bolsa h6 .emphasis,
  .content-bolsa h5 .emphasis {
    color: rgb(239, 72, 87);
  }

  .content-bolsa span {
    font-weight: bold;
  }

  .content-bolsa .info-prova {
    width: 100%;
    height: auto;
    display: flex;
    align-items: left;
    justify-content: left;
    flex-direction: column;
  }

  .content-bolsa .info-prova h4 {
    font-size: 22px;
    font-weight: bold;
  }

  .content-bolsa .info-prova ul {
    margin-left: 2%;
  }
  .content-bolsa .info-prova ul li span {
    font-weight: bold;
  }
  .content-bolsa .info-prova ul li {
    padding: 5px 0px;
  }
  .content-bolsa .info-prova ul li a {
    font-weight: bold;
    color: #333333;
    text-decoration: none;
  }
  .content-bolsa .info-prova ul li a:hover {
    font-weight: bold;
    color: rgb(239, 72, 87);
    text-decoration: none;
    transition: all 0.3s ease;
  }

  .button-inscricao .btn_insc {
    height: 56px;
    width: 35% !important;
  }

  .button-inscricao .btn_inscricao {
    border: 2px solid rgb(239, 72, 87);
    border-radius: 5px;
    background-color: rgb(239, 72, 87);
    // box-shadow: 0px 0px 30px rgba(1, 41, 141, 0.25);
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
  }

  .button-inscricao .btn_inscricao span {
    color: #ffffff;
    text-transform: uppercase;
  }

  .content-bolsa-font {
    font-family: "Clan-Book Book", sans-serif;
    font-size: 16px;
  }
}

@media only screen and (max-width: 768px) {
  .main-bolsa {
    width: 100%;
    height: auto;
    font-family: "Clan-Book Book", sans-serif;
    font-size: 16px;
  }

  .title_page {
    margin: -10px 0px -10px;
    padding: 55px 0px 50px;
    background-repeat: repeat;
    background-position: center;
    background-color: rgb(259, 72, 87);
    background-image: url("https://d1jehvsxq7tgfk.cloudfront.net/sitecpv/images/cpv-fundo-4.png");
    border-radius: 0;
  }

  .title_page h1 {
    font-size: 41px;
    font-weight: 700;
    color: #ffffff;
    text-transform: uppercase;
  }

  .adjustment-breadcrumb {
    margin-top: 0px !important;
  }

  .header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .header h4 {
    font-size: 26px;
    font-weight: bold;
    line-height: 1.385;
    letter-spacing: 0.81px;
    text-transform: uppercase;
    text-align: center;
    color: rgb(58, 28, 83);
  }

  .header h4 .emphasis {
    color: rgb(239, 72, 87);
  }

  .content-bolsa {
    width: 100%;
    display: flex;
    align-items: left;
    justify-content: left;
    flex-direction: column;
    color: #333333;
  }

  .content-bolsa h6,
  h5 {
    font-size: 20px;
    color: rgb(58, 28, 83);
  }

  .content-bolsa h6 .emphasis,
  .content-bolsa h5 .emphasis {
    color: rgb(239, 72, 87);
  }

  .content-bolsa span {
    font-weight: bold;
  }

  .content-bolsa .info-prova {
    width: 100%;
    height: auto;
    display: flex;
    align-items: left;
    justify-content: left;
    flex-direction: column;
  }

  .content-bolsa .info-prova h4 {
    font-size: 22px;
    font-weight: bold;
  }

  .content-bolsa .info-prova ul {
    margin-left: 2%;
  }
  .content-bolsa .info-prova ul li span {
    font-weight: bold;
  }
  .content-bolsa .info-prova ul li {
    padding: 5px 0px;
  }
  .content-bolsa .info-prova ul li a {
    font-weight: bold;
    color: #333333;
    text-decoration: none;
  }
  .content-bolsa .info-prova ul li a:hover {
    font-weight: bold;
    color: rgb(239, 72, 87);
    text-decoration: none;
    transition: all 0.3s ease;
  }

  .button-inscricao .btn_insc {
    height: 56px;
    width: 35% !important;
  }

  .button-inscricao .btn_inscricao {
    border: 2px solid rgb(239, 72, 87);
    border-radius: 5px;
    background-color: rgb(239, 72, 87);
    // box-shadow: 0px 0px 30px rgba(1, 41, 141, 0.25);
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
  }

  .button-inscricao .btn_inscricao span {
    color: #ffffff;
    text-transform: uppercase;
  }

  .content-bolsa-font {
    font-family: "Clan-Book Book", sans-serif;
    font-size: 16px;
  }
}
</style>
